const FAI_ROOT = '/financial-intermediary/us/en/';
const INSTITUTIONAL_ROOT = '/institutional/us/en/products/';
const INSTITUTIONAL_TICKER_ROOT = `${INSTITUTIONAL_ROOT}us-mutual-fund.overview.html?scrollToProductCode=`;

const OVERLAY_QUERY_PARAMETER = `?src=piModal`;

export const humanFriendlyPageMap = {
    default: 'fund information',
    'target-date-funds': 'Target Date funds',
    'bond-funds': 'bond funds',
    'money-market-funds': 'money market funds',
    'asset-allocation-funds': 'asset allocation funds',
    'international-stocks': 'international equity funds',
    'us-equity': 'U.S. equity funds',
    etf: 'ETFs'
};

const pageURLMap = {
    default: {
        fai: `investment-research-tool.html${OVERLAY_QUERY_PARAMETER}#investment=mutualfund`,
        institutional: `us-mutual-fund.table.html${OVERLAY_QUERY_PARAMETER}`
    },
    etf: { fai: 'investments/etfs.html' },
    'target-date-funds': {
        fai: `investment-research-tool.html${OVERLAY_QUERY_PARAMETER}#investment=mutualfund&assetClass=target+date`,
        institutional: `us-mutual-fund.overview.html?assetClass=Asset%20Allocation&assetAllocation=target-date${OVERLAY_QUERY_PARAMETER}`
    },
    'us-equity': {
        fai: `investment-research-tool.html#investment=mutualfund&assetClass=u.s.+equity`
    },
    'asset-allocation-funds': {
        fai: `investment-research-tool.html#investment=mutualfund&assetClass=asset+allocation`
    },
    'bond-funds': {
        fai: `investment-research-tool.html#investment=mutualfund&assetClass=fixed+income`,
        institutional: 'us-mutual-fund.overview.html?assetClass=Fixed%20Income'
    },
    'international-stocks': {
        fai: `investment-research-tool.html#investment=mutualfund&assetClass=international+equity`
    },
    'money-market-funds': {
        fai: `investment-research-tool.html#investment=mutualfund&assetClass=money+market`
    }
};

const tickerMap = {
    TCHP: {
        fai: 'etfs/blue-chip-growth-etf.html'
    },
    TDVG: {
        fai: 'etfs/dividend-growth-etf.html'
    },
    TEQI: {
        fai: 'etfs/equity-income-etf.html'
    },
    TGRW: {
        fai: 'etfs/growth-stock-etf.html'
    },
    TRCLX: {
        fai: 'mutual-funds/us-products/china-evolution-equity-fund/i-class.html'
    },
    TRGVX: {
        fai:
            'mutual-funds/us-products/global-value-equity-i-class/investor-class.html'
    },
    PRIGX: {
        fai: 'mutual-funds/us-products/global-value-equity-i-class.html',
        institutional:
            'IGV&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRGOX: {
        fai:
            'mutual-funds/us-products/large-cap-growth-i-class/investor-class.html'
    },
    TRLGX: {
        fai: 'mutual-funds/us-products/large-cap-growth-i-class.html',
        institutional:
            'LCG&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    TRLUX: {
        fai:
            'mutual-funds/us-products/large-cap-growth-i-class/investor-class.html'
    },
    TILCX: {
        fai: 'mutual-funds/us-products/large-cap-value-i-class.html',
        institutional:
            'LCV&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    TSBLX: {
        fai: 'mutual-funds/us-products/qm-us-bond-index-fund/i-class.html'
    },
    TRSJX: {
        fai: 'mutual-funds/us-products/retirement-2065-fund.html'
    },
    TRFKX: {
        fai: 'mutual-funds/us-products/retirement-i-2065.html'
    },
    PRSLX: {
        fai: 'mutual-funds/us-products/target-2065-fund.html'
    },
    RPFDX: {
        fai: 'mutual-funds/us-products/target-2065-fund/i-class.html'
    },
    TSDLX: {},
    TSIDX: {},
    TRBCX: {
        fai: `mutual-funds/us-products/blue-chip-growth-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `BCG&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#${OVERLAY_QUERY_PARAMETER}`
    },
    PRNHX: {
        fai: `mutual-funds/us-products/new-horizons-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `NHF&assetClass=Equity&assetAllocation=&tierThree=small-cap|credit#${OVERLAY_QUERY_PARAMETER}`
    },
    PRWCX: {
        fai: `mutual-funds/us-products/capital-appreciation-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `CAF&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#${OVERLAY_QUERY_PARAMETER}`
    },
    PRGFX: {
        fai: `mutual-funds/us-products/growth-stock-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `GSF&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#${OVERLAY_QUERY_PARAMETER}`
    },
    PRHSX: {
        fai: `mutual-funds/us-products/health-sciences-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `HSF&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#${OVERLAY_QUERY_PARAMETER}`
    },
    PRDGX: {
        fai: `mutual-funds/us-products/dividend-growth-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `DGF&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#${OVERLAY_QUERY_PARAMETER}`
    },
    PRGTX: {
        fai: `mutual-funds/us-products/global-technology-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `GTF&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#${OVERLAY_QUERY_PARAMETER}`
    },
    TRRCX: {
        fai: 'mutual-funds/us-products/retirement-2030-fund.html',
        institutional:
            'RPC&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    TRRHX: {
        fai: `mutual-funds/us-products/retirement-2025-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `RPH&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#${OVERLAY_QUERY_PARAMETER}`
    },
    RPMGX: {
        fai: `mutual-funds/us-products/mid-cap-growth-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `MCG&assetClass=Equity&assetAllocation=&tierThree=mid-cap|credit#${OVERLAY_QUERY_PARAMETER}`
    },
    TRRBX: {
        fai: 'mutual-funds/us-products/retirement-2020-fund.html',
        institutional:
            'RPB&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    TRRMX: {
        fai: 'mutual-funds/us-products/retirement-2050-fund.html',
        institutional:
            'RPL&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    PRMTX: {
        fai: `mutual-funds/us-products/communications-and-technology-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `MTF&assetClass=Equity&assetAllocation=&tierThree=sector|credit#${OVERLAY_QUERY_PARAMETER}`
    },
    PRFDX: {
        fai: `mutual-funds/us-products/equity-income-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `EIF&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#${OVERLAY_QUERY_PARAMETER}`
    },
    PREIX: {
        fai: `mutual-funds/us-products/equity-index-500-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `EXF&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#${OVERLAY_QUERY_PARAMETER}`
    },
    TRRDX: {
        fai: `mutual-funds/us-products/retirement-2040-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `RPD&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#${OVERLAY_QUERY_PARAMETER}`
    },
    TRRJX: {
        fai: `mutual-funds/us-products/retirement-2035-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `RPI&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#${OVERLAY_QUERY_PARAMETER}`
    },
    TRRNX: {
        fai: 'mutual-funds/us-products/retirement-2055-fund.html',
        institutional:
            'RPM&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    PRSCX: {
        fai: `mutual-funds/us-products/science-and-technology-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `STF&assetClass=Equity&assetAllocation=&tierThree=sector|credit#${OVERLAY_QUERY_PARAMETER}`
    },
    TRRKX: {
        fai: 'mutual-funds/us-products/retirement-2045-fund.html',
        institutional:
            'RPK&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    MDXBX: {
        fai: `mutual-funds/us-products/maryland-tax-free-bond-fund.html${OVERLAY_QUERY_PARAMETER}`
    },
    TBCIX: {
        fai: 'mutual-funds/us-products/blue-chip-growth-fund/i-class.html',
        institutional:
            'BCI&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    TRRLX: {
        fai: `mutual-funds/us-products/retirement-2060-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `RPN&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#${OVERLAY_QUERY_PARAMETER}`
    },
    OTCFX: {
        fai: 'mutual-funds/us-products/small-cap-stock-fund.html',
        institutional:
            'SCS&assetClass=Equity&assetAllocation=&tierThree=small-cap|credit#'
    },
    PRDSX: {
        fai: `mutual-funds/us-products/qm-us-small-cap-growth-equity.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `DSG&assetClass=Equity&assetAllocation=&tierThree=small-cap|credit#${OVERLAY_QUERY_PARAMETER}`
    },
    PRVAX: {
        fai: `mutual-funds/us-products/virginia-tax-free-bond-fund.html${OVERLAY_QUERY_PARAMETER}`
    },
    RPBAX: {
        fai: 'mutual-funds/us-products/balanced-fund.html'
    },
    PRNEX: {
        fai: 'mutual-funds/us-products/new-era-fund.html',
        institutional:
            'NEF&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRREX: {
        fai: 'mutual-funds/us-products/real-estate-fund.html',
        institutional:
            'REF&assetClass=Equity&assetAllocation=&tierThree=sector|credit#'
    },
    PRGSX: {
        fai: 'mutual-funds/us-products/global-stock-fund.html',
        institutional:
            'GLS&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    PRRXX: {
        fai: 'mutual-funds/us-products/government-money-fund.html'
    },
    PRHYX: {
        fai: 'mutual-funds/us-products/high-yield-fund.html',
        institutional:
            'HYF&assetClass=Fixed%20Income&assetAllocation=&tierThree=high-yield#'
    },
    TRVLX: {
        fai: 'mutual-funds/us-products/value-fund.html',
        institutional:
            'VAL&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    RPSIX: {
        fai: 'mutual-funds/us-products/spectrum-income-fund.html'
    },
    PRIDX: {
        fai: 'mutual-funds/us-products/international-discovery-fund.html',
        institutional:
            'IDF&assetClass=Equity&assetAllocation=&tierThree=small-cap|credit#'
    },
    PREFX: {
        fai: `mutual-funds/us-products/tax-efficient-equity-fund.html${OVERLAY_QUERY_PARAMETER}`
    },
    PRWAX: {
        fai: `mutual-funds/us-products/new-america-growth-fund.html${OVERLAY_QUERY_PARAMETER}`,
        institutional: `NAG&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#${OVERLAY_QUERY_PARAMETER}`
    },
    PRMSX: {
        fai: 'mutual-funds/us-products/emerging-markets-stock-fund.html',
        institutional:
            'EMS&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TSCXX: {
        fai: 'mutual-funds/us-products/cash-reserves-fund.html'
    },
    TRRGX: {
        fai: 'mutual-funds/us-products/retirement-2015-fund.html',
        institutional:
            'RPG&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    PRTXX: {
        fai: 'mutual-funds/us-products/us-treasury-money-fund.html'
    },
    PRSVX: {
        fai: 'mutual-funds/us-products/small-cap-value-fund.html',
        institutional:
            'SCV&assetClass=Equity&assetAllocation=&tierThree=small-cap|credit#'
    },
    TRMCX: {
        fai: 'mutual-funds/us-products/mid-cap-value-fund.html',
        institutional:
            'MCV&assetClass=Equity&assetAllocation=&tierThree=mid-cap|credit#'
    },
    TRRAX: {
        fai: 'mutual-funds/us-products/retirement-2010-fund.html',
        institutional:
            'RPA&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    PRIJX: {
        fai:
            'mutual-funds/us-products/emerging-markets-discovery-stock-fund.html',
        institutional:
            'EMV&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    GTFBX: {
        fai: 'mutual-funds/us-products/georgia-tax-free-bond-fund.html'
    },
    TRSGX: {
        fai:
            'mutual-funds/us-products/spectrum-moderate-growth-allocation-fund.html'
    },
    PRFHX: {
        fai: 'mutual-funds/us-products/tax-free-high-yield-fund.html'
    },
    PRNYX: {
        fai: 'mutual-funds/us-products/new-york-tax-free-bond-fund.html'
    },
    POMIX: {
        fai: 'mutual-funds/us-products/total-equity-market-index-fund.html',
        institutional:
            'TMX&assetClass=Equity&assetAllocation=&tierThree=credit#'
    },
    PRASX: {
        fai: 'mutual-funds/us-products/new-asia-fund.html',
        institutional:
            'NAS&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRBUX: {
        fai: 'mutual-funds/us-products/ultra-short-term-bond-fund.html',
        institutional:
            'SBF&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    PRCIX: {
        fai: 'mutual-funds/us-products/new-income-fund.html',
        institutional:
            'NIF&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    PRITX: {
        fai: 'mutual-funds/us-products/international-stock-fund.html',
        institutional:
            'ISF&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    PRJIX: {
        fai: 'mutual-funds/us-products/new-horizons-fund/i-class.html',
        institutional:
            'NHI&assetClass=Equity&assetAllocation=&tierThree=small-cap|credit#'
    },
    PREMX: {
        fai: 'mutual-funds/us-products/emerging-markets-bond-fund.html',
        institutional:
            'EMB&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    PRSNX: {
        fai: 'mutual-funds/us-products/global-multi-sector-bond-fund.html',
        institutional:
            'SNF&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    PRWBX: {
        fai: 'mutual-funds/us-products/short-term-bond-fund.html',
        institutional:
            'STB&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    PRAFX: {
        fai: 'mutual-funds/us-products/real-assets-fund.html'
    },
    PRUFX: {
        fai: 'mutual-funds/us-products/growth-stock-fund/i-class.html',
        institutional:
            'GSI&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    PRCOX: {
        fai: 'mutual-funds/us-products/us-equity-research-fund.html',
        institutional:
            'COF&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    PRSIX: {
        fai:
            'mutual-funds/us-products/spectrum-conservative-allocation-fund.html'
    },
    PRDMX: {
        fai: 'mutual-funds/us-products/diversified-mid-cap-growth-fund.html',
        institutional:
            'DMG&assetClass=Equity&assetAllocation=&tierThree=mid-cap|credit#'
    },
    TRRIX: {
        fai: 'mutual-funds/us-products/retirement-balanced-fund.html',
        institutional:
            'RPE&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    TRGXX: {
        fai: 'mutual-funds/us-products/us-treasury-money-fund/i-class.html'
    },
    TRLAX: {},
    TROSX: {
        fai: 'mutual-funds/us-products/overseas-stock-fund.html',
        institutional:
            'OSF&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    PRGIX: {
        fai: 'mutual-funds/us-products/growth-income-fund.html',
        institutional:
            'GIF&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    PRSGX: {
        fai: 'mutual-funds/us-products/spectrum-growth-fund.html'
    },
    TRAIX: {
        fai: 'mutual-funds/us-products/capital-appreciation-fund/i-class.html',
        institutional:
            'CAI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    PRLAX: {
        fai: 'mutual-funds/us-products/latin-america-fund.html',
        institutional:
            'LAM&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRRFX: {
        fai: 'mutual-funds/us-products/retirement-2005-fund.html',
        institutional:
            'RPJ&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    TRPBX: {
        fai: 'mutual-funds/us-products/spectrum-moderate-allocation-fund.html'
    },
    PRTAX: {
        fai: 'mutual-funds/us-products/tax-free-income-fund.html'
    },
    PDGIX: {
        fai: 'mutual-funds/us-products/dividend-growth-fund/i-class.html',
        institutional:
            'DGI&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    PRFRX: {
        fai: 'mutual-funds/us-products/floating-rate-fund.html',
        institutional:
            'FRI&assetClass=Fixed%20Income&assetAllocation=&tierThree=high-yield#'
    },
    RPGAX: {
        fai: 'mutual-funds/us-products/global-allocation-fund.html'
    },
    TUHYX: {
        fai:
            'mutual-funds/us-products/u-s--high-yield-i-class/investor-class.html'
    },
    PBDIX: {
        fai: 'mutual-funds/us-products/qm-us-bond-index-fund.html',
        institutional:
            'UBX&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    PRULX: {
        fai: 'mutual-funds/us-products/us-treasury-long-term-index-fund.html'
    },
    PRJPX: {
        fai: 'mutual-funds/us-products/japan-fund.html',
        institutional:
            'JAF&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    PRISX: {
        fai: 'mutual-funds/us-products/financial-services-fund.html',
        institutional:
            'FSF&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRAMX: {
        fai: 'mutual-funds/us-products/africa-and-middle-east-fund.html',
        institutional:
            'AME&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRAOX: {
        fai: 'mutual-funds/us-products/asia-opportunities-fund.html',
        institutional:
            'AOF&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    PRGMX: {
        fai: 'mutual-funds/us-products/gnma-fund.html'
    },
    RPGEX: {
        fai: 'mutual-funds/us-products/global-growth-stock-fund.html',
        institutional:
            'GLE&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    PRINX: {
        fai: 'mutual-funds/us-products/summit-municipal-income-fund.html'
    },
    PRXCX: {
        fai: 'mutual-funds/us-products/california-tax-free-bond-fund.html'
    },
    PRESX: {
        fai: 'mutual-funds/us-products/european-stock-fund.html',
        institutional:
            'ESF&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    PRSMX: {
        fai: 'mutual-funds/us-products/summit-municipal-intermediate-fund.html'
    },
    TRULX: {
        fai: 'mutual-funds/us-products/us-large-cap-core-fund.html',
        institutional:
            'LCF&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    PEXMX: {
        fai: 'mutual-funds/us-products/extended-equity-market-index-fund.html',
        institutional:
            'XMX&assetClass=Equity&assetAllocation=&tierThree=mid-cap|credit#'
    },
    RPIBX: {
        fai: 'mutual-funds/us-products/international-bond-fund.html',
        institutional:
            'IBF&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    TIDDX: {
        fai:
            'mutual-funds/us-products/international-discovery-fund/i-class.html',
        institutional:
            'IDI&assetClass=Equity&assetAllocation=&tierThree=small-cap|credit#'
    },
    PIEQX: {
        fai: 'mutual-funds/us-products/international-equity-index-fund.html',
        institutional:
            'IXF&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRBRX: {
        fai: 'mutual-funds/us-products/retirement-i-2020.html',
        institutional:
            'RFI&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    PRPIX: {
        fai: 'mutual-funds/us-products/corporate-income-fund.html',
        institutional:
            'CIF&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    PTTFX: {
        fai: 'mutual-funds/us-products/total-return.html',
        institutional:
            'TTF&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    NJTFX: {
        fai: 'mutual-funds/us-products/new-jersey-tax-free-bond-fund.html'
    },
    TRIGX: {
        fai: 'mutual-funds/us-products/international-value-equity-fund.html',
        institutional:
            'IGI&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    PRFSX: {
        fai: 'mutual-funds/us-products/tax-free-short-intermediate-fund.html'
    },
    PRTIX: {
        fai: 'mutual-funds/us-products/us-treasury-intermediate-index-fund.html'
    },
    TMSRX: {
        fai: 'mutual-funds/us-products/multi-strategy-total-return-fund.html'
    },
    TQAIX: {
        fai:
            'mutual-funds/us-products/qm-us-small-cap-growth-equity/i-class.html',
        institutional:
            'QAI&assetClass=Equity&assetAllocation=&tierThree=small-cap|credit#'
    },
    TQSMX: {
        fai:
            'mutual-funds/us-products/qm-u-s--small---mid-cap-core-equity-fund.html',
        institutional:
            'QSM&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    RPIHX: {
        fai: 'mutual-funds/us-products/global-high-income-bond-fund.html',
        institutional:
            'GHI&assetClass=Fixed%20Income&assetAllocation=&tierThree=high-yield#'
    },
    RPTIX: {
        fai: 'mutual-funds/us-products/mid-cap-growth-fund/i-class.html',
        institutional:
            'MCI&assetClass=Equity&assetAllocation=&tierThree=mid-cap|credit#'
    },
    PTEXX: {
        fai: 'mutual-funds/us-products/tax-exempt-money-fund.html'
    },
    PGLOX: {
        fai: 'mutual-funds/us-products/global-consumer-fund.html',
        institutional:
            'GCF&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    RPIEX: {
        fai: 'mutual-funds/us-products/dynamic-global-bond-fund.html',
        institutional:
            'GUN&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    PRIPX: {
        fai: 'mutual-funds/us-products/inflation-protected-bond-fund.html',
        institutional:
            'IPB&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    PSILX: {
        fai: 'mutual-funds/us-products/spectrum-international-fund.html'
    },
    PRCPX: {
        fai: 'mutual-funds/us-products/credit-opportunities-fund.html',
        institutional:
            'CRO&assetClass=Fixed%20Income&assetAllocation=&tierThree=high-yield#'
    },
    PRZIX: {
        fai:
            'mutual-funds/us-products/emerging-markets-stock-fund/i-class.html',
        institutional:
            'ESI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRPKX: {
        fai: 'mutual-funds/us-products/retirement-i-2045.html',
        institutional:
            'RKI&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    TRTFX: {
        fai: 'mutual-funds/us-products/target-2060-fund.html'
    },
    TRPCX: {
        fai: 'mutual-funds/us-products/retirement-i-2030.html',
        institutional:
            'RHI&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    TRGRX: {
        fai: 'mutual-funds/us-products/global-real-estate-fund.html',
        institutional:
            'GRE&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TROIX: {
        fai: 'mutual-funds/us-products/overseas-stock-fund/i-class.html',
        institutional:
            'OSI&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    TRPLX: {
        fai: 'mutual-funds/us-products/retirement-i-2060.html',
        institutional:
            'ROI&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    PRELX: {
        fai:
            'mutual-funds/us-products/emerging-markets-local-currency-bond-fund.html',
        institutional:
            'EML&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    PGTIX: {
        fai: 'mutual-funds/us-products/global-technology-fund/i-class.html',
        institutional:
            'GTI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    RPIDX: {
        fai: 'mutual-funds/us-products/dynamic-credit-fund.html'
    },
    PRCNX: {
        fai:
            'mutual-funds/us-products/international-disciplined-equity-fund.html',
        institutional:
            'ICN&assetClass=Equity&assetAllocation=&tierThree=credit#'
    },
    REIPX: {
        fai: 'mutual-funds/us-products/equity-income-fund/i-class.html',
        institutional:
            'EII&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    TRPHX: {
        fai: 'mutual-funds/us-products/retirement-i-2025.html',
        institutional:
            'RGI&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    OTIIX: {
        fai: 'mutual-funds/us-products/small-cap-stock-fund/i-class.html',
        institutional:
            'SSI&assetClass=Equity&assetAllocation=&tierThree=small-cap|credit#'
    },
    TREMX: {
        fai: 'mutual-funds/us-products/emerging-europe-fund.html',
        institutional:
            'EEM&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRECX: {
        fai:
            'mutual-funds/us-products/emerging-markets-corporate-bond-fund.html',
        institutional:
            'EMC&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    PRVIX: {
        fai: 'mutual-funds/us-products/small-cap-value-fund/i-class.html',
        institutional:
            'VSI&assetClass=Equity&assetAllocation=&tierThree=small-cap|credit#'
    },
    TIRRX: {
        fai: 'mutual-funds/us-products/real-estate-fund/i-class.html',
        institutional:
            'RSI&assetClass=Equity&assetAllocation=&tierThree=sector|credit#'
    },
    TRRWX: {
        fai: 'mutual-funds/us-products/target-2030-fund.html'
    },
    TMDXX: {
        fai: 'mutual-funds/us-products/maryland-tax-free-money-fund.html'
    },
    TRMIX: {
        fai: 'mutual-funds/us-products/mid-cap-value-fund/i-class.html',
        institutional:
            'MVI&assetClass=Equity&assetAllocation=&tierThree=mid-cap|credit#'
    },
    PRHIX: {
        fai: 'mutual-funds/us-products/high-yield-fund/i-class.html',
        institutional:
            'HII&assetClass=Fixed%20Income&assetAllocation=&tierThree=high-yield#'
    },
    TNIBX: {
        fai:
            'mutual-funds/us-products/international-bond-fund--usd-hedged-.html'
    },
    PRXEX: {
        fai: 'mutual-funds/us-products/new-income-fund/i-class.html',
        institutional:
            'NII&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    PRUIX: {
        fai: 'mutual-funds/us-products/equity-index-500-fund/i-class.html',
        institutional:
            'EXI&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    TRNEX: {
        fai: 'mutual-funds/us-products/new-era-fund/i-class.html',
        institutional:
            'NEI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRPIX: {
        fai: 'mutual-funds/us-products/value-fund/i-class.html',
        institutional:
            'VAI&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    TRPNX: {
        fai: 'mutual-funds/us-products/retirement-i-2055.html',
        institutional:
            'RNI&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    TRGLX: {
        fai: 'mutual-funds/us-products/global-stock-fund/i-class.html',
        institutional:
            'GLI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRPDX: {
        fai: 'mutual-funds/us-products/retirement-i-2040.html',
        institutional:
            'RJI&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    PCTXX: {
        fai: 'mutual-funds/us-products/california-tax-free-money-fund.html'
    },
    TRSXX: {
        fai: 'mutual-funds/us-products/summit-municipal-money-market.html'
    },
    THISX: {
        fai: 'mutual-funds/us-products/health-sciences-fund/i-class.html',
        institutional:
            'HSI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    NYTXX: {
        fai: 'mutual-funds/us-products/new-york-tax-free-money-fund.html'
    },
    TRBFX: {
        fai:
            'mutual-funds/us-products/limited-duration-inflation-focused-bond-fund.html',
        institutional:
            'STI&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    TRRVX: {
        fai: 'mutual-funds/us-products/target-2025-fund.html'
    },
    TRPMX: {
        fai: 'mutual-funds/us-products/retirement-i-2050.html',
        institutional:
            'RMI&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    TRFGX: {
        fai: 'mutual-funds/us-products/retirement-i-2015.html',
        institutional:
            'RDI&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    TRPJX: {
        fai: 'mutual-funds/us-products/retirement-i-2035.html',
        institutional:
            'RII&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    RCLIX: {
        fai: 'mutual-funds/us-products/us-large-cap-core-fund/i-class.html',
        institutional:
            'LCI&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    RPTFX: {
        fai: 'mutual-funds/us-products/target-2045-fund.html'
    },
    TRFFX: {
        fai: 'mutual-funds/us-products/target-2055-fund.html'
    },
    RPGIX: {
        fai: 'mutual-funds/us-products/global-industrials-fund.html',
        institutional:
            'IND&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRRUX: {
        fai: 'mutual-funds/us-products/target-2020-fund.html'
    },
    PCCOX: {
        fai: 'mutual-funds/us-products/us-equity-research-fund/i-class.html',
        institutional:
            'COI&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    TQMVX: {
        fai: 'mutual-funds/us-products/qm-u-s--value-equity-fund.html',
        institutional:
            'QMV&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    PRIMX: {
        fai:
            'mutual-funds/us-products/summit-municipal-income-fund/i-class.html'
    },
    PNAIX: {
        fai: 'mutual-funds/us-products/new-america-growth-fund/i-class.html',
        institutional:
            'NAI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRHRX: {
        fai: 'mutual-funds/us-products/target-2040-fund.html'
    },
    TSNIX: {
        fai:
            'mutual-funds/us-products/science-and-technology-fund/i-class.html',
        institutional:
            'SNI&assetClass=Equity&assetAllocation=&tierThree=sector|credit#'
    },
    TRPTX: {
        fai: 'mutual-funds/us-products/retirement-balanced-i-fund-i-class.html',
        institutional:
            'RQI&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    TBSIX: {
        fai: 'mutual-funds/us-products/short-term-bond-fund/i-class.html',
        institutional:
            'SBI&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    PTYIX: {
        fai: 'mutual-funds/us-products/tax-free-high-yield-fund/i-class.html'
    },
    RBAIX: {
        fai: 'mutual-funds/us-products/balanced-fund/i-class.html'
    },
    RPTTX: {
        fai:
            'mutual-funds/us-products/diversified-mid-cap-growth-fund/i-class.html',
        institutional:
            'DMI&assetClass=Equity&assetAllocation=&tierThree=mid-cap|credit#'
    },
    PGMSX: {
        fai:
            'mutual-funds/us-products/global-multi-sector-bond-fund/i-class.html',
        institutional:
            'GMI&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    TQGEX: {
        fai: 'mutual-funds/us-products/qm-global-equity-fund.html',
        institutional:
            'QGE&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    PNSIX: {
        fai: 'mutual-funds/us-products/new-asia-fund/i-class.html',
        institutional:
            'NSI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TGIPX: {
        fai:
            'mutual-funds/us-products/spectrum-moderate-growth-allocation-fund/i-class.html'
    },
    TTMIX: {
        fai:
            'mutual-funds/us-products/communications-and-technology-fund/i-class.html',
        institutional:
            'MTI&assetClass=Equity&assetAllocation=&tierThree=sector|credit#'
    },
    TRFOX: {
        fai: 'mutual-funds/us-products/target-2050-fund.html'
    },
    PRMDX: {
        fai:
            'mutual-funds/us-products/maryland-short-term-tax-free-bond-fund.html'
    },
    PRXIX: {
        fai: 'mutual-funds/us-products/emerging-markets-bond-fund/i-class.html',
        institutional:
            'EBI&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    TUHIX: {
        fai: 'mutual-funds/us-products/u-s--high-yield-i-class.html'
    },
    TEEFX: {
        fai: 'mutual-funds/us-products/tax-efficient-equity-fund/i-class.html'
    },
    TPPAX: {
        fai:
            'mutual-funds/us-products/spectrum-moderate-allocation-fund/i-class.html'
    },
    TTGXX: {
        fai: 'mutual-funds/us-products/government-money-fund/i-class.html'
    },
    PRAMX: {
        fai:
            'mutual-funds/us-products/africa-and-middle-east-fund/i-class.html',
        institutional:
            'AMI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRPFX: {
        fai: 'mutual-funds/us-products/retirement-i-2005.html',
        institutional:
            'RBI&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    PRIUX: {
        fai: 'mutual-funds/us-products/international-stock-fund/i-class.html',
        institutional:
            'ISI&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    TFILX: {
        fai: 'mutual-funds/us-products/tax-free-income-fund/i-class.html'
    },
    PPIPX: {
        fai:
            'mutual-funds/us-products/spectrum-conservative-allocation-fund/i-class.html'
    },
    TRRTX: {
        fai: 'mutual-funds/us-products/target-2015-fund.html'
    },
    PRIHX: {
        fai:
            'mutual-funds/us-products/intermediate-tax-free-high-yield-fund.html'
    },
    TRPAX: {
        fai: 'mutual-funds/us-products/retirement-i-2010.html',
        institutional:
            'RCI&assetClass=Asset%20Allocation&assetAllocation=target-date&tierThree=retirement#'
    },
    REVIX: {
        fai:
            'mutual-funds/us-products/emerging-markets-discovery-stock-fund/i-class.html',
        institutional:
            'EVI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRARX: {
        fai: 'mutual-funds/us-products/target-2005-fund.html'
    },
    RGGIX: {
        fai: 'mutual-funds/us-products/global-growth-stock-fund/i-class.html',
        institutional:
            'GGI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TQSIX: {
        fai:
            'mutual-funds/us-products/qm-u-s--small---mid-cap-core-equity-fund/i-class.html',
        institutional:
            'QSI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRSTX: {
        fai: 'mutual-funds/us-products/ultra-short-term-bond-fund/i-class.html',
        institutional:
            'UBI&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    RPGRX: {
        fai: 'mutual-funds/us-products/target-2035-fund.html'
    },
    TGAFX: {
        fai: 'mutual-funds/us-products/global-allocation-fund/i-class.html'
    },
    TTSIX: {
        fai:
            'mutual-funds/us-products/tax-free-short-intermediate-fund/i-class.html'
    },
    TFBVX: {
        fai: 'mutual-funds/us-products/virginia-tax-free-bond-fund/i-class.html'
    },
    RPISX: {
        fai: 'mutual-funds/us-products/international-bond-fund/i-class.html',
        institutional:
            'IBI&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    PRIKX: {
        fai: 'mutual-funds/us-products/real-assets-fund/i-class.html'
    },
    TGTIX: {
        fai: 'mutual-funds/us-products/growth-income-fund/i-class.html',
        institutional:
            'GII&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    PRTMX: {
        fai:
            'mutual-funds/us-products/summit-municipal-intermediate-fund/i-class.html'
    },
    TRNXX: {
        fai:
            'mutual-funds/us-products/new-york-tax-free-money-fund/i-class.html'
    },
    TECIX: {
        fai:
            'mutual-funds/us-products/emerging-markets-corporate-bond-fund/i-class.html',
        institutional:
            'ECI&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    RICIX: {
        fai:
            'mutual-funds/us-products/international-disciplined-equity-fund/i-class.html',
        institutional:
            'ICI&assetClass=Equity&assetAllocation=&tierThree=credit#'
    },
    TOORX: {
        fai: 'mutual-funds/us-products/target-2050-fund/i-class.html'
    },
    TFBIX: {
        fai: 'mutual-funds/us-products/maryland-tax-free-bond-fund/i-class.html'
    },
    RPELX: {
        fai: 'mutual-funds/us-products/dynamic-credit-fund/i-class.html'
    },
    TFIFX: {
        fai: 'mutual-funds/us-products/financial-services-fund/i-class.html',
        institutional:
            'FII&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TWRRX: {
        fai: 'mutual-funds/us-products/target-2030-fund/i-class.html'
    },
    TRROX: {
        fai: 'mutual-funds/us-products/target-2010-fund.html'
    },
    TRTIX: {
        fai:
            'mutual-funds/us-products/international-value-equity-fund/i-class.html',
        institutional:
            'ILI&assetClass=Equity&assetAllocation=&tierThree=large-cap|credit#'
    },
    RLAIX: {
        fai: 'mutual-funds/us-products/latin-america-fund/i-class.html',
        institutional:
            'LAI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRASX: {
        fai: 'mutual-funds/us-products/asia-opportunities-fund/i-class.html',
        institutional:
            'ASI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    RJAIX: {
        fai: 'mutual-funds/us-products/japan-fund/i-class.html',
        institutional:
            'JAI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TEIMX: {
        fai:
            'mutual-funds/us-products/emerging-markets-local-currency-bond-fund/i-class.html',
        institutional:
            'EMI&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    TIIPX: {
        fai:
            'mutual-funds/us-products/inflation-protected-bond-fund/i-class.html',
        institutional:
            'IPI&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    PRUUX: {
        fai:
            'mutual-funds/us-products/us-treasury-long-term-index-fund/i-class.html'
    },
    TBGAX: {
        fai: 'mutual-funds/us-products/georgia-tax-free-bond-fund/i-class.html'
    },
    TFAIX: {
        fai: 'mutual-funds/us-products/floating-rate-fund/i-class.html',
        institutional:
            'FAI&assetClass=Fixed%20Income&assetAllocation=&tierThree=high-yield#'
    },
    RPEIX: {
        fai: 'mutual-funds/us-products/dynamic-global-bond-fund/i-class.html',
        institutional:
            'GUI&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    TNBMX: {
        fai:
            'mutual-funds/us-products/international-bond-fund--usd-hedged-/i-class.html'
    },
    RPOIX: {
        fai:
            'mutual-funds/us-products/global-high-income-bond-fund/i-class.html',
        institutional:
            'GBI&assetClass=Fixed%20Income&assetAllocation=&tierThree=high-yield#'
    },
    TCFEX: {
        fai:
            'mutual-funds/us-products/california-tax-free-bond-fund/i-class.html'
    },
    TCELX: {
        fai: 'mutual-funds/us-products/china-evolution-equity-fund.html'
    },
    PRKIX: {
        fai:
            'mutual-funds/us-products/us-treasury-intermediate-index-fund/i-class.html'
    },
    TICCX: {
        fai: 'mutual-funds/us-products/corporate-income-fund/i-class.html',
        institutional:
            'CII&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    TCRRX: {
        fai: 'mutual-funds/us-products/credit-opportunities-fund/i-class.html',
        institutional:
            'CRI&assetClass=Fixed%20Income&assetAllocation=&tierThree=high-yield#'
    },
    TTURX: {
        fai: 'mutual-funds/us-products/target-2020-fund/i-class.html'
    },
    PTKIX: {
        fai: 'mutual-funds/us-products/total-return/i-class.html',
        institutional:
            'TKI&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    TQVIX: {
        fai: 'mutual-funds/us-products/qm-u-s--value-equity-fund/i-class.html',
        institutional:
            'QVI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRVVX: {
        fai: 'mutual-funds/us-products/target-2025-fund/i-class.html'
    },
    TRMUX: {
        fai:
            'mutual-funds/us-products/maryland-short-term-tax-free-bond-fund/i-class.html'
    },
    TRJIX: {
        fai:
            'mutual-funds/us-products/new-jersey-tax-free-bond-fund/i-class.html'
    },
    TIRGX: {
        fai: 'mutual-funds/us-products/global-real-estate-fund/i-class.html',
        institutional:
            'GEI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    PRXAX: {
        fai: 'mutual-funds/us-products/gnma-fund/i-class.html'
    },
    TRLDX: {
        fai:
            'mutual-funds/us-products/limited-duration-inflation-focused-bond-fund/i-class.html',
        institutional:
            'LDI&assetClass=Fixed%20Income&assetAllocation=&tierThree=credit#'
    },
    TRYIX: {
        fai: 'mutual-funds/us-products/new-york-tax-free-bond-fund/i-class.html'
    },
    TMSSX: {
        fai:
            'mutual-funds/us-products/multi-strategy-total-return-fund/i-class.html'
    },
    TERXX: {
        fai: 'mutual-funds/us-products/tax-exempt-money-fund/i-class.html'
    },
    TEUIX: {
        fai: 'mutual-funds/us-products/european-stock-fund/i-class.html',
        institutional:
            'EUI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRGAX: {
        fai: 'mutual-funds/us-products/global-industrials-fund/i-class.html',
        institutional:
            'INI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TFRRX: {
        fai: 'mutual-funds/us-products/target-2005-fund/i-class.html'
    },
    TTRTX: {
        fai: 'mutual-funds/us-products/target-2015-fund/i-class.html'
    },
    TPGPX: {
        fai: 'mutual-funds/us-products/target-2035-fund/i-class.html'
    },
    TRXRX: {
        fai: 'mutual-funds/us-products/target-2040-fund/i-class.html'
    },
    TTOIX: {
        fai: 'mutual-funds/us-products/target-2060-fund/i-class.html'
    },
    TCBXX: {
        fai:
            'mutual-funds/us-products/california-tax-free-money-fund/i-class.html'
    },
    TRPPX: {
        fai: 'mutual-funds/us-products/target-2055-fund/i-class.html'
    },
    TQGIX: {
        fai: 'mutual-funds/us-products/qm-global-equity-fund/i-class.html',
        institutional:
            'QGI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TRFWX: {
        fai: 'mutual-funds/us-products/target-2045-fund/i-class.html'
    },
    TTEEX: {
        fai: 'mutual-funds/us-products/emerging-europe-fund/i-class.html',
        institutional:
            'EEI&assetClass=Equity&assetAllocation=&tierThree=multi-cap|credit#'
    },
    TFHAX: {
        fai:
            'mutual-funds/us-products/intermediate-tax-free-high-yield-fund/i-class.html'
    },
    TWNXX: {
        fai:
            'mutual-funds/us-products/maryland-tax-free-money-fund/i-class.html'
    },
    TORFX: {
        fai: 'mutual-funds/us-products/target-2010-fund/i-class.html'
    }
};

const wDef = (def, fn) => (arg) => fn(arg || def);

const mkGet = (type, root, lookup, def) =>
    wDef(
        def,
        (what) =>
            lookup[what] && lookup[what][type] && `${root}${lookup[what][type]}`
    );

export const getPageFAIUrl = mkGet('fai', FAI_ROOT, pageURLMap, 'default');
export const getPageInstitutionalUrl = mkGet(
    'institutional',
    INSTITUTIONAL_ROOT,
    pageURLMap,
    'default'
);

export const getFundFAIUrl = mkGet('fai', `${FAI_ROOT}investments/`, tickerMap);
export const getFundInstitutionalUrl = mkGet(
    'institutional',
    INSTITUTIONAL_TICKER_ROOT,
    tickerMap
);
